import { post } from './axiosHelper';
import challengerEnv from '../lib/challengerEnv.js';
import {
  IEPostFormData,
} from './IePost';

const submitDocuments = async function (data: IEPostFormData) {

  const url = `${challengerEnv().apiBaseUrl}/external/correspondence-enquiries/v1/api/documents`;
  const requestData = formData(data);
  if (challengerEnv().mockApiResponses) {
    return getMockResponse(require('../../cypress/fixtures/epost/mock-epost-success.json'));
  }
  return await post(url, requestData, 'multipart/form-data');
};

const getMockResponse = function (response) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(response), Math.random() * 3000);
  });
};

const formData = (data: IEPostFormData) => {
  let formData = new FormData();

  formData.append('requestType', data.requestType);
  // form data can only be strings and files so instead of sending "null" send empty string

  formData.append('supportingInformation', data.supportingInformation || "");
  data.files.forEach((file) => {
    formData.append('files', file, file.name)
  })
  return formData;

}

export { submitDocuments };